<template>
  <div class="overview">
    <div class="content">
      <!--      <el-steps :active="1">-->
      <!--        <el-step description="Registrations are open, sign up now!">-->
      <!--          <template #title>-->
      <!--              <div style="padding-bottom: 10PX">Registration</div>-->
      <!--          </template>-->
      <!--        </el-step>-->
      <!--        <el-step description="Confirm your attendance to secure your place in the tournament.">-->
      <!--          <template #title>-->
      <!--            <div style="padding-bottom: 10PX">Confirmation <span style="padding-left: 60PX">Deadline: SAT . 14:00</span></div>-->
      <!--          </template>-->
      <!--        </el-step>-->
      <!--        <el-step description="The tournament has started.">-->
      <!--          <template #title>-->
      <!--            <div style="padding-bottom: 10PX">Start <span style="padding-left: 60PX">SAT . 17:00</span></div>-->
      <!--          </template>-->
      <!--        </el-step>-->
      <!--      </el-steps>-->

      <div class="detail" style="padding-top: 0">
        <p class="title">Livestream Replay</p>
        <p class="img" v-if="matchDetail.match.mp4">
          <video :src="matchDetail.match.mp4" autoplay controls></video>
        </p>
        <p class="img" v-else>
          <img :src="matchDetail.match.image" alt="" class="object-contain bg-black"/>
        </p>
        <div class="flex">
          <div class="format-container">
            <div class="format">
              <p class="title">Format</p>
              <div
                class="format-detail"
                v-if="matchDetail.match.matchDiff !== 6"
              >
                <div class="item">
                  <div class="icon">
                    <img :src="matchDetail.match.appImage" alt="" />
                  </div>
                  <div class="name">Game & Region</div>
                  <div>{{ matchDetail.match.supportGame }}</div>
                </div>
                <div class="item">
                  <div class="icon">
                    <img src="@/assets/web/tournaments/icon1.png" alt="" />
                  </div>
                  <div class="name">Check-in period</div>
                  <div>{{ matchDetail.match.checkin }}</div>
                </div>
                <div class="item">
                  <div class="icon">
                    <img src="@/assets/web/tournaments/icon2.png" alt="" />
                  </div>
                  <div class="name">Team size</div>
                  <div>
                    {{
                      matchDetail.match.name.includes("Sidekick")
                        ? "128 Teams"
                        : matchDetail.match.mlimit
                    }}
                  </div>
                </div>
                <div class="item">
                  <div class="icon">
                    <img src="@/assets/web/tournaments/icon3.png" alt="" />
                  </div>
                  <div class="name">Entry fee</div>
                  <div>£ {{ matchDetail.match.fee }}</div>
                </div>
                <div class="item">
                  <div class="icon">
                    <img src="@/assets/web/tournaments/icon4.png" alt="" />
                  </div>
                  <div class="name">Prize pool</div>
                  <div style="color: #ffb20e">
                    {{
                      matchDetail.match.name.includes("Sidekick") ? "€" : "£"
                    }}
                    {{ matchDetail.match.totalPrize }}
                  </div>
                </div>
                <div class="item">
                  <div class="icon">
                    <img src="@/assets/web/tournaments/icon5.png" alt="" />
                  </div>
                  <div class="name">Format</div>
                  <div>
                    {{
                      matchDetail.match.name.includes("Sidekick")
                        ? "5V5 Summoner's Rift"
                        : "Single Elimination"
                    }}
                  </div>
                </div>
              </div>
              <div class="format-detail" v-else>
                <div class="item">
                  <div class="icon">
                    <img src="@/assets/web/tournaments/icon1.png" alt="" />
                  </div>
                  <div class="name">Draw Time</div>
                  <div>{{ matchDetail.match.checkin }}</div>
                </div>
                <div class="item">
                  <div class="icon">
                    <img src="@/assets/web/tournaments/icon2.png" alt="" />
                  </div>
                  <div class="name">Participants</div>
                  <div>{{ matchDetail.match.mlimit }}</div>
                </div>
                <div class="item">
                  <div class="icon">
                    <img src="@/assets/web/tournaments/icon3.png" alt="" />
                  </div>
                  <div class="name">Entry fee</div>
                  <div>£ {{ matchDetail.match.fee }}</div>
                </div>
                <div class="item">
                  <div class="icon">
                    <img src="@/assets/web/tournaments/icon4.png" alt="" />
                  </div>
                  <div class="name">Prize pool</div>
                  <div style="color: #ffb20e">
                    {{
                      matchDetail.match.name.includes("Sidekick") ? "€" : "£"
                    }}
                    {{ matchDetail.match.totalPrize }}
                  </div>
                </div>
                <div class="item">
                  <div class="icon">
                    <img src="@/assets/web/tournaments/icon5.png" alt="" />
                  </div>
                  <div class="name">Format</div>
                  <div>
                    {{
                      matchDetail.match.name.includes("Sidekick")
                        ? "5V5 Summoner's Rift"
                        : "Single Elimination"
                    }}
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="information"> -->
            <!--              <p class="title">Information</p>-->
            <!--              <div>-->
            <!--                <p>Rules:</p>-->
            <!--                <p v-html="matchDetail.match.rules"></p>-->
            <!--              </div>-->
            <!--              <div>-->
            <!--                <p>Reports:</p>-->
            <!--                <p>You can report players for cheating, toxicity etc etc etc etc etc.</p>-->
            <!--              </div>-->
            <!-- </div> -->
            <div class="players-container">
              <div class="players">
                <p class="title">Players</p>
                <div class="players-detail">
                  <div class="num">
                    <div>
                      <p>Viewed</p>
                      <p>{{ matchDetail.match.clicktime }}</p>
                    </div>
                    <div>
                      <p>Registered</p>
                      <p>
                        {{ matchDetail.part ? matchDetail.part.length : 0 }}
                      </p>
                    </div>
                    <div>
                      <p>Total</p>
                      <p>{{ matchDetail.match.mlimit }}</p>
                    </div>
                    <!--                  <div>-->
                    <!--                    <p>Slots</p>-->
                    <!--                    <p>25</p>-->
                    <!--                  </div>-->
                  </div>
                  <div class="participants">
                    <div class="user-img" v-if="matchDetail.part">
                      <img
                        :src="item.memberPhoto"
                        alt=""
                        v-for="(item, index) in matchDetail.part.slice(0, 5)"
                        :key="index"
                      />
                    </div>
                    <p style="font-size: 22px" v-if="matchDetail.part">
                      {{ matchDetail.part[0].nickName
                      }}<span v-if="matchDetail.part.length >= 2"
                        >, {{ matchDetail.part[1].nickName }}</span
                      ><span v-if="matchDetail.part.length >= 3"
                        >, {{ matchDetail.part[2].nickName }}</span
                      ><span v-if="matchDetail.part.length > 3">
                        and {{ matchDetail.part.length - 3 }} others are
                        registered.</span
                      >
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <!--            <div class="results" v-if="matchDetail.match.matchDiff === 0">-->
            <!--              <p class="title">Results</p>-->
            <!--              <div class="results-detail">-->
            <!--                <div class="item">-->
            <!--                  <div>-->
            <!--                    <p><img class="ranking" src="@/assets/web/tournaments/ranking1st.png" alt=""></p>-->
            <!--                    <p>1st</p>-->
            <!--                  </div>-->
            <!--                  <div>-->
            <!--                    <p><img class="user-header" src="" alt=""></p>-->
            <!--                    <p>The random user</p>-->
            <!--                  </div>-->
            <!--                  <p>£15.00</p>-->
            <!--                </div>-->
            <!--                <div class="item">-->
            <!--                  <div>-->
            <!--                    <p><img class="ranking" src="@/assets/web/tournaments/ranking2nd.png" alt=""></p>-->
            <!--                    <p>2st</p>-->
            <!--                  </div>-->
            <!--                  <div>-->
            <!--                    <p><img class="user-header" src="" alt=""></p>-->
            <!--                    <p>The random user</p>-->
            <!--                  </div>-->
            <!--                  <p>£15.00</p>-->
            <!--                </div>-->
            <!--                <div class="item">-->
            <!--                  <div>-->
            <!--                    <p><img class="ranking" src="@/assets/web/tournaments/ranking3td.png" alt=""></p>-->
            <!--                    <p>3st</p>-->
            <!--                  </div>-->
            <!--                  <div>-->
            <!--                    <p><img class="user-header" src="" alt=""></p>-->
            <!--                    <p>The random user</p>-->
            <!--                  </div>-->
            <!--                  <p>£15.00</p>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            </div>-->
            <!--            <div class="settings">-->
            <!--              <p class="title">Settings</p>-->
            <!--              <p><img src="" alt=""></p>-->
            <!--            </div>-->
          </div>
          <div class="hosted-by">
            <div>
              <p class="title">Hosted by</p>
              <div class="last-detail">
                <img src="@/assets/head.png" alt="" />
                <p>SideQuest</p>
              </div>
            </div>
            <!--              <div>-->
            <!--                <p class="title">Admins</p>-->
            <!--                <div class="last-detail">-->
            <!--                  <img src="" alt="">-->
            <!--                  <div>-->
            <!--                    <p>Someone <img src="@/assets/sidequest-logo-x.png" alt=""></p>-->
            <!--                    <p>Owners</p>-->
            <!--                  </div>-->
            <!--                </div>-->
            <!--              </div>-->
            <div>...</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { inject } from "vue";

export default {
  name: "overview-content",
  setup() {
    const matchDetail = inject("matchDetail");
    return {
      matchDetail,
    };
  },
};
</script>

<style scoped lang="scss">
@use "@/styles/base" as *;

.overview {
  padding-top: 75px;
  :deep(.content) {
    .el-steps {
      padding: 0 230px 0 20px;
      .el-step__line {
        top: 50%;
      }
      .el-step__icon {
        width: 56px;
        height: 56px;
        background: #1a1e29;
        border: none;
        color: #1a1e29;
      }
      .el-step__main {
        .el-step__title {
          font-size: 20px;
          color: #555f76;
        }
        .el-step__description {
          font-size: 16px;
          color: #555f76;
        }
      }

      .is-finish {
        color: #ffffff !important;
        .el-step__icon {
          background: #ffb20e;
          color: #ffb20e;
        }
      }
    }

    .detail {
      padding-top: 150px;
      padding-bottom: 70px;
      .title {
        color: #ffffff;
        font-size: 28px;
      }
      .img {
        width: 420px;
        height: 240px;
        border-radius: 14px;
        background: #bbbbbb;
        margin: 20px 0 66px;
        overflow: hidden;

        @include media("<tablet") {
          width: 100%;
        }

        img {
          width: 100%;
          height: 100%;
        }
        video {
          width: 100%;
          height: 100%;
        }
      }

      .flex {
        display: flex;
        flex-direction: column;
        gap: 32px;

        .format-container {
          display: flex;
          justify-items: center;
          gap: 32px;

          @include media("<tablet") {
            flex-direction: column;
          }

          .format {
            flex: 2;

            .format-detail {
              display: grid;
              justify-content: space-between;
              grid-template-columns: repeat(3, 1fr);
              flex-wrap: wrap;
              gap: 16px;

              @include media("<phone") {
                grid-template-columns: repeat(2, 1fr);
              }

              .item {
                padding: 30px 24px;
                border: 1px solid #9aa0b0;
                margin-top: 26px;
                border-radius: 12px;

                .icon {
                  img {
                    height: 40px;
                    width: 40px;
                    border-radius: 2px;
                    object-fit: cover;
                  }
                }
                .name {
                  color: #ffffff;
                  padding: 10px 0;
                }
                div {
                  font-size: 20px;
                  color: #bbbbbb;
                }
              }
            }
          }

          .information {
            padding-top: 100px;
            color: #ffffff;
            font-size: 22px;

            p {
              padding: 10px;
            }

            > div:nth-child(2) {
              padding-top: 26px;
            }

            > div:nth-child(3) {
              padding-top: 108px;
            }
          }

          .players-container {
            flex: 1;

            .players {
              .players-detail {
                border: 1px solid #9aa0b0;
                margin-top: 26px;
                border-radius: 12px;
                color: #ffffff;
                padding: 30px 12px;

                .num {
                  width: 100%;
                  display: flex;
                  justify-content: space-evenly;
                  text-align: center;
                  color: #bbbbbb;
                  font-size: 1rem;

                  div > p:nth-child(2) {
                    font-size: 1.4rem;
                    color: #ffffff;
                    padding-top: 16px;
                  }
                }

                .participants {
                  padding: 30px 12px;

                  .user-img {
                  height: 78px;
                  margin: 50px 0 14px;
                  position: relative;
                  img {
                    width: 76px;
                    height: 76px;
                    position: absolute;
                    background: #bbbbbb;
                    border-radius: 50%;
                    top: 0;
                    left: 0;
                    border: 2px solid #0f1317;
                    z-index: 5;
                  }
                  img:nth-child(2) {
                    left: 60px;
                    z-index: 4;
                  }
                  img:nth-child(3) {
                    left: 120px;
                    z-index: 3;
                  }
                  img:nth-child(4) {
                    left: 180px;
                    z-index: 2;
                  }
                  img:nth-child(5) {
                    left: 240px;
                    z-index: 1;
                  }
                  }
                }

              }
            }
          }
        }

        .hosted-by {
          padding-top: 150px;
          color: #ffffff;

          .title {
            padding-bottom: 20px;
          }

          img {
            width: 96px;
            height: 96px;
            border-radius: 50%;
            background: #bbbbbb;
            margin-right: 10px;
          }

          .last-detail {
            display: flex;
            justify-content: flex-start;
            font-size: 20px;
            align-items: center;

            div {
              img {
                width: 27px;
                height: 27px;
                border-radius: 0;
                background: none;
                margin-left: 10px;
              }

              p {
                display: flex;
                align-items: center;
                line-height: 30px;
              }
            }
          }
        }

        .results {
          padding-top: 100px;
        }
        .results-detail {
          width: calc(28.54vw - 48px);
          border: 1px solid #9aa0b0;
          margin-top: 26px;
          border-radius: 12px;
          color: #ffffff;
          padding: 20px 24px 16px;
          .item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid #bbbbbb;
            padding: 10px 0;
            font-size: 22px;
            div {
              display: flex;
              justify-content: flex-start;
              align-items: center;
              img {
                margin-right: 10px;
              }
            }
            .user-header {
              width: 58px;
              height: 58px;
              border-radius: 50%;
            }
          }
        }
        .results-detail > .item:last-child {
          border: none;
        }

        .settings {
          padding-top: 100px;
          img {
            width: 100%;
            height: 294px;
            margin-top: 18px;
          }
        }
      }
    }
  }
}
</style>
